import React, { useEffect, useState } from "react";
import "./../Styles/viewdesigner.css";
import { API, UPLOADS } from "./../../config/api";

export default function ViewDesigner() {
  const [designers, setDesigners] = useState([]);
  const [editData, setEditData] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Get user session
  const savedUser = sessionStorage.getItem("user");
  const user = savedUser ? JSON.parse(savedUser) : null;

  const skillList = ["Malti", "Sequien", "Cording", "Beads", "Chain"];

  useEffect(() => {
    if (user?.id) {
      fetchDesigners();
    }
  }, [user]);

  /* ================= FETCH ================= */
  const fetchDesigners = async () => {
    try {
      const res = await fetch(`${API.USER_DESIGNERS}&user_id=${user.id}`);
      const data = await res.json();
      setDesigners(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  /* ================= UPDATE ================= */
  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      formData.append("id", editData.id);
      formData.append("name", editData.name);
      formData.append("email", editData.email);
      formData.append("phone", editData.phone);
      formData.append("experience", editData.experience);
      formData.append("skills", editData.skills);
      formData.append("location", editData.location);
      formData.append("expected_salary", editData.expected_salary);
      formData.append("description", editData.description);

      if (editData.profile instanceof File) {
        formData.append("profile", editData.profile);
      }

      setLoading(true);

      const res = await fetch(API.UPDATE_DESIGNERS, {
        method: "POST",
        body: formData,
      });

      const text = await res.text(); // 👈 IMPORTANT
      console.log("Server Response:", text);

      const data = JSON.parse(text);

      setLoading(false);

      if (data.status) {
        alert("Designer Updated Successfully");
        setEditData(null);
        fetchDesigners();
      } else {
        alert(data.message || "Update Failed");
      }
    } catch (error) {
      console.error("Update Error:", error);
      setLoading(false);
      alert("Server Error");
    }
  };
  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this designer?")) return;

    const formData = new FormData();
    formData.append("id", id);

    await fetch(API.DELETE_DESIGNER, {
      method: "POST",
      body: formData,
    });

    fetchDesigners();
  };

  return (
    <div className="dashboard-content">
      <h2>My Designer Listings</h2>

      {/* CARD GRID */}
      <div className="product-grid">
        {designers.length > 0 ? (
          designers.map((item) => (
            <div className="machine-card" key={item.id}>
              {/* IMAGE */}
              <div className="machine-img-container">
                <img
                  src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                  alt={item.name}
                  onError={(e) =>
                    (e.target.src = "https://via.placeholder.com/300x250")
                  }
                />
              </div>

              {/* BODY */}
              <div className="machine-body">
                <h4 className="machine-name">{item.name}</h4>

                {/* PHONE */}
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <div className="price-block">
                    <span className="currency-symbol">₹</span>
                    <span className="amount">
                      {Number(item.expected_salary).toLocaleString("en-IN")}
                    </span>
                  </div>

                  <button className="contact-btn">
                    <i className="bi bi-telephone-fill me-1"></i>
                    Contact
                  </button>
                </div>

                {/* SKILLS */}
                <div className="spec-row mt-2">
                  <div className="spec-item">
                    <span className="spec-label">Skills:</span>
                    <span className="spec-value">{item.skills}</span>
                  </div>

                  <div className="spec-item">
                    <span className="spec-label">Exp:</span>
                    <span className="spec-value">{item.experience}</span>
                  </div>
                </div>

                {/* LOCATION */}
                <div className="location-info">
                  <i className="bi bi-geo-alt-fill"></i>
                  {item.location}
                </div>

                {/* STATUS */}
                <div className="mt-2">
                  <span className={`status ${item.status?.toLowerCase()}`}>
                    {item.status}
                  </span>
                </div>

                {/* FOOTER BUTTONS */}
                <div className="machine-actions mt-3">
                  <button
                    className="action-btn view-action"
                    onClick={() => setViewData(item)}
                    title="View"
                  >
                    <i className="bi bi-eye-fill"></i>
                  </button>

                  <button
                    className="action-btn edit-action"
                    onClick={() => setEditData(item)}
                    title="Edit"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    className="action-btn delete-action"
                    onClick={() => handleDelete(item.id)}
                    title="Delete"
                  >
                    <i className="bi bi-trash-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No Designers Found</p>
        )}
      </div>

      {/* VIEW POPUP */}
      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>Designer Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="text-center mb-3">
              <img
                src={`${UPLOADS.DESIGNER_IMAGE}${viewData.profile}`}
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
                alt="profile"
              />
            </div>

            <div className="popup-grid">
              <div>
                <label>Name</label>
                <p>{viewData.name}</p>
              </div>
              <div>
                <label>Email</label>
                <p>{viewData.email}</p>
              </div>
              <div>
                <label>Phone</label>
                <p>{viewData.phone}</p>
              </div>
              <div>
                <label>Experience</label>
                <p>{viewData.experience}</p>
              </div>
              <div>
                <label>Salary</label>
                <p>₹ {viewData.expected_salary}</p>
              </div>
              <div>
                <label>Skills</label>
                <p>{viewData.skills}</p>
              </div>
              <div>
                <label>Location</label>
                <p>{viewData.location}</p>
              </div>
            </div>

            <div className="description-box">
              <label>Description</label>
              <p>{viewData.description}</p>
            </div>
          </div>
        </div>
      )}

      {/* EDIT POPUP */}
      {editData && (
        <div className="popup-overlay">
          <div className="popup-box large-popup">
            <div className="popup-header">
              <h3>Edit Designer</h3>

              <button
                className="close-icon-btn"
                onClick={() => setEditData(null)}
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleUpdate}>
              <div className="popup-grid">
                <div>
                  <label>Name</label>
                  <input
                    type="text"
                    value={editData.name}
                    onChange={(e) =>
                      setEditData({ ...editData, name: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label>Email</label>
                  <input
                    type="email"
                    value={editData.email}
                    onChange={(e) =>
                      setEditData({ ...editData, email: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label>Phone</label>
                  <input
                    type="text"
                    value={editData.phone}
                    onChange={(e) =>
                      setEditData({ ...editData, phone: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label>Experience</label>
                  <input
                    type="text"
                    value={editData.experience}
                    onChange={(e) =>
                      setEditData({ ...editData, experience: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label>Salary</label>
                  <input
                    type="number"
                    value={editData.expected_salary}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        expected_salary: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Location</label>
                  <input
                    type="text"
                    value={editData.location}
                    onChange={(e) =>
                      setEditData({ ...editData, location: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* Skills */}

              <div className="mt-3">
                <label>Skills</label>

                <div className="designer-skill-grid">
                  {skillList.map((skill) => (
                    <div key={skill} className="designer-skill-box">
                      <input
                        type="checkbox"
                        checked={editData.skills?.includes(skill)}
                        onChange={() => {
                          let skills = editData.skills || "";

                          let arr = skills.split(",").map((s) => s.trim());

                          if (arr.includes(skill)) {
                            arr = arr.filter((s) => s !== skill);
                          } else {
                            arr.push(skill);
                          }

                          setEditData({
                            ...editData,
                            skills: arr.join(", "),
                          });
                        }}
                      />

                      <span>{skill}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Description */}

              <div className="mt-3">
                <label>Description</label>

                <textarea
                  value={editData.description}
                  onChange={(e) =>
                    setEditData({ ...editData, description: e.target.value })
                  }
                />
              </div>

              {/* Image */}

              <div className="mt-3">
                <label>Profile Image</label>

                <input
                  type="file"
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      profile: e.target.files[0],
                    })
                  }
                />
              </div>

              <div className="mt-4 text-end">
                <button
                  className="designer-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Designer"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
